<script setup>
import { computed } from 'vue'
import { Plane } from 'lucide-vue-next'
import Card from './Card.vue'
import CtaButton from './CtaButton.vue'
import AircraftSilhouette from './AircraftSilhouette.vue'
import { status, STATUS } from '../lib/status'
import { PART_LAYOUT, labelTransform } from '../lib/aircraftMap'

const props = defineProps({
  parts: { type: Array, required: true },
})

const points = computed(() =>
  props.parts
    .filter((p) => PART_LAYOUT[p.part])
    .map((p) => ({ ...p, ...PART_LAYOUT[p.part], tone: status(p.state) })),
)

const legend = ['done', 'in_progress', 'pending']
</script>

<template>
  <Card title="Mapa da aeronave" :icon="Plane" link-label="Ver detalhes" link-href="/mapa">
    <div class="relative mx-auto aspect-[4/3] w-full max-w-sm">
      <!-- Ilustração: vista superior simplificada -->
      <svg viewBox="0 0 200 150" class="absolute left-1/2 top-0 h-full w-[58%] -translate-x-1/2" role="img" aria-label="Vista superior da aeronave">
        <AircraftSilhouette />
      </svg>

      <!-- Pontos de status -->
      <ul>
        <li
          v-for="point in points"
          :key="point.part"
          class="absolute flex items-center gap-2"
          :style="{
            top: point.top,
            left: point.left,
            transform: labelTransform(point.side),
          }"
          :class="point.side === 'left' && 'flex-row-reverse'"
        >
          <span class="h-3 w-3 shrink-0 rounded-full ring-2 ring-white" :class="point.tone.dot" aria-hidden="true" />
          <span class="whitespace-nowrap text-xs font-medium text-up-navy">
            {{ point.part }}
            <span class="sr-only"> — {{ point.tone.label }}</span>
          </span>
        </li>
      </ul>
    </div>

    <ul class="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
      <li v-for="state in legend" :key="state" class="flex items-center gap-2 text-xs text-slate-600">
        <span class="h-2.5 w-2.5 rounded-full" :class="STATUS[state].dot" aria-hidden="true" />
        {{ STATUS[state].label }}
      </li>
    </ul>

    <div class="mt-auto pt-5">
      <CtaButton href="/mapa" variant="outline">Ver mapa completo</CtaButton>
    </div>
  </Card>
</template>
